/** Just enough routing for a handful of pages: the address bar is the state. */
import { useEffect, useState, type AnchorHTMLAttributes } from 'react';

export function navigate(to: string, { replace = false } = {}) {
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  dispatchEvent(new PopStateEvent('popstate'));
}

/** A `next` address from the query string, if it is a page of this site; otherwise `fallback`. */
export const safeNext = (next: string | null, fallback = '/') =>
  next && next.startsWith('/') && !next.startsWith('//') && !next.startsWith('/\\') ? next : fallback;

export function useLocation(): URL {
  const [href, setHref] = useState(location.href);
  useEffect(() => {
    const on = () => setHref(location.href);
    addEventListener('popstate', on);
    return () => removeEventListener('popstate', on);
  }, []);
  return new URL(href);
}

export function Link({ href, onClick, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement> & { href: string }) {
  return (
    <a
      href={href}
      onClick={(e) => {
        onClick?.(e);
        if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(href);
      }}
      {...rest}
    />
  );
}
